document.addEventListener('DOMContentLoaded', (event) => {
  axios('assets/json/video-' + appLanguage + '.json').
    then(function (response) {
      if (response) {
        new videosGrid(response.data, 'video-grid--container', null, 0, 1, null, true)
      }
    }).catch(function (error) {
    // handle error
    console.log(error)
  })
});